import script from "./EmojiPickerWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./EmojiPickerWrapper.vue?vue&type=script&setup=true&lang=js"

import "./EmojiPickerWrapper.vue?vue&type=style&index=0&id=347cfcc9&lang=scss"

const __exports__ = script;

export default __exports__